<template>
  <div class="servidores-olt-vlan">
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">
                <label class="custom-control custom-checkbox">
                  <input type="checkbox" v-model="selectAll" v-on:click="toggleCheckboxVlan()" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description"></span>
                </label>
              </th>
              <th width="65">VLAN</th>
              <th>Descrição</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="vlan in vlans" :key="vlan.id" :class="cssRowVlan(vlan)" class="cursor-pointer">
                <td scope="row">
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="vlan._checked" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"></span>
                  </label>
                </td>
                <td v-on:click="handleEditaVlanOlt(vlan)">{{vlan.vlan}}</td>
                <td v-on:click="handleEditaVlanOlt(vlan)">{{vlan.descricao}}</td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>

    <!-- modal-edita-vlan -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-vlan" id="btn-modal-edita-vlan-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-vlan" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!vlanOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Inserir nova VLAN
            </h5>
            <h5 v-if="!!vlanOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando VLAN
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <button type="button" v-on:click="handleRemoveVlanOlt(vlanOlt.data)" class="btn btn-outline-danger btn-sm float-end">
                  <font-awesome-icon :icon="['fas', 'trash']" fixed-width/> Excluir
                </button>
              </div>

              <div class="col-12 col-sm-8 col-md-9 col-lg-10 mb-2">
                <label class="custom-control custom-checkbox">
                  <input type="checkbox" v-model="vlanOlt.data.visivel" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description ps-1">Visível</span>
                </label>
              </div>

              <div class="col-12 col-sm-8 col-md-9 col-lg-10 mb-2">
                <label>Descrição</label>
                <input v-model="vlanOlt.data.descricao" type="text" class="form-control">
              </div>

              <div class="col-12 col-sm-4 col-md-3 col-lg-2 mb-2">
                <label>VLAN</label>
                <input v-model.number="vlanOlt.data.vlan" v-bind:disabled="(vlanOlt.data.id)" type="number" min="1" max="4096" class="form-control">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-vlan-fecha">Fechar</button>
            <button type="button"
                v-if="!vlanOlt.data.id"
                v-on:click="handleModalVlanOltCadastrar()"
                v-bind:disabled="!podeSalvarVlanOlt()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="(vlanOlt.data.id)"
                v-on:click="handleModalVlanOltSalvar()"
                v-bind:disabled="!podeSalvarVlanOlt()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-vlan -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresOLTVlan',

  components: {
    Paginador,
  },

  data() {
    return {
      oltID: undefined,
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      selectAll: false,
      vlans: [],
      vlanOlt: {
        data: {
          id: undefined,
          olt_id: 0,
          descricao: '',
          vlan: 0,
          tipo: undefined,
        },
      }
    }
  },

  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/olt/${this.oltID}/vlans?${this.paginador.requestParams}&orderBy[vlan]=asc`).then(res => {
        loading(false);
        this.selectAll = false;
        this.vlans = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    resetModalVlanOlt() {
      this.vlanOlt.data.id = undefined;
      this.vlanOlt.data.olt_id = this.oltID;
      this.vlanOlt.data.descricao = '';
      this.vlanOlt.data.vlan = 0;
    },

    handleAdicionar() {
      this.resetModalVlanOlt();
      this.abreModalCadastroVlanOlt();
    },

    cssRowVlan(vlan) {
      switch (true) {
        case (!vlan):
          return [];

        case (!vlan.visivel):
          return ['text-muted-2'];
      }

      return ['text-info'];
    },

    toggleCheckboxVlan() {
      this.vlans.forEach(x => {x._checked = !this.selectAll});
    },

    // MODAL
    handleEditaVlanOlt(vlan) {
      this.resetModalVlanOlt();
      this.vlanOlt.data = clone(vlan);
      this.abreModalCadastroVlanOlt();
    },

    handleRemoveVlanOlt(vlan) {
      dialogo.confirmacao(`Confirma remover a VLAN <b>${vlan.id} - ${vlan.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/servidores/olt/${this.oltID}/vlans/${vlan.id}`).then(() => {
          loading(false);

          this.fechaModalCadastroVlanOlt();
          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroVlanOlt() {
      document.getElementById('btn-modal-edita-vlan-abre').click();
    },

    fechaModalCadastroVlanOlt() {
      document.getElementById('btn-modal-edita-vlan-fecha').click();
    },

    podeSalvarVlanOlt() {
      switch (true) {
        case (this.vlanOlt.data.descricao.length < 1):
        case (this.vlanOlt.data.vlan <= 0):
          return false;

        default:
          return true;
      }
    },

    handleModalVlanOltCadastrar() {
      const sendData = {
        visivel: this.vlanOlt.data.visivel,
        descricao: this.vlanOlt.data.descricao,
        vlan: this.vlanOlt.data.vlan,
      };

      loading(true);

      api.post(`/servidores/olt/${this.oltID}/vlans`, sendData).then(() => {
        loading(false);
        this.fechaModalCadastroVlanOlt();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalVlanOltSalvar() {
      const sendData = {
        id: this.vlanOlt.data.id,
        visivel: this.vlanOlt.data.visivel,
        descricao: this.vlanOlt.data.descricao,
        vlan: this.vlanOlt.data.vlan,
      };

      loading(true);

      api.put(`/servidores/olt/${this.oltID}/vlans/${sendData.id}`, sendData).then(() => {
        loading(false);
        this.fechaModalCadastroVlanOlt();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },

  created() {
    const oltID = +this.$route.params.oltID;

    if (!oltID) {
      this.$router.push({ path: `/configuracoes/servidores` });
      return;
    }

    this.oltID = oltID;

    this.handlePesquisa();
  },

  computed: {
    podeRemoverSelecionados() {
      return this.vlans.some(x => x._checked === true);
    },
  },
}
</script>
